// Test Result Operations Class
// -----------------------------
//

import TestResultsClass from "./testResult";

class TestResultOperationsClass {
  // Sort By Due Date
  // -----------------
  // Sorts vulns by the due date
  //
  sortByTestDate(listOfTests: TestResultsClass[]): TestResultsClass[] {
    // Copy the array so we dont overwrite the old one
    var tests = listOfTests.slice();
    return tests.sort(this.sortByTestDateInObject);
  }

  /*********************************/
  /*        SORT FUNCTIONS         */
  /*********************************/

  // Sort by Date Test Conducted
  sortByTestDateInObject(
    test1: TestResultsClass,
    test2: TestResultsClass
  ): number {
    if (test1.startTime > test2.startTime) {
      return -1;
    }
    if (test1.startTime < test2.startTime) {
      return 1;
    }
    return 0;
  }
}

export default TestResultOperationsClass;
